const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const observer =
  typeof IntersectionObserver !== "undefined"
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              entry.target.classList.add("v-reveal--visible");
              observer?.unobserve(entry.target);
            }
          }
        },
        { threshold: 0.15 },
      )
    : null;

export default {
  mounted(el: HTMLElement) {
    el.classList.add("v-reveal");

    if (prefersReducedMotion() || !observer) {
      el.classList.add("v-reveal--visible");
      return;
    }

    observer.observe(el);
  },
};
